const loadingLabel = "Načítám";
const csCZ = {
  loadingLabel
};
export {
  csCZ as default,
  loadingLabel
};
